/* @flow */

/**
 * Load a polyfill for Element.classList if necessary. If a polyfill is not
 * required, the promise resolves instantly. This function assumes that `loadJS`
 * is attached to the window Object.
 *
 * @returns {Promise} Promise
 */
export function polyfillClassList(): Promise<void> {
  return new Promise((resolve, reject) => {
    if ('classList' in document.createElement('div')) {
      resolve();
    } else {
      const script = window.loadJS(
        'https://cdnjs.cloudflare.com/ajax/libs/classlist/1.2.20171210/classList.min.js',
        resolve,
      );

      script.onerror = () => {
        reject(new Error('Unable to load polyfillClassList'));
      };
    }
  });
}
